<template>
  <section>
    <DonationHeader />
    <DonationIntro />
    <DonationBullets />
    <DonationHow />
    <DonationMore />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Donation',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.donation || {}
    }
  },
  mounted() {
    console.log('donation', this.$wp.pages.donation)
  }
}
</script>
